/* eslint-disable no-unused-expressions */
import React from 'react';

import './index.scss';

function forgottosavemodal({bodycontent, modalId, submitAction, title = "Your unsaved changes will not be submitted.", label = "Submit"}) {
  const renderSubmitDesign = () => (
    <div className='cb-btn-row footerbottomRow'>
      {/* <!-- close button --> */}
      <button type='button' className='cb-btn cb-btn-naked' data-cb-modal-close aria-label='Continue editing'>Continue Editing</button>
      <button type='button' className='cb-btn cb-btn-primary' onClick={submitAction} data-cb-modal-close aria-label='Continue without saving'>{`${label} Without Saving`}</button>
    </div>
  );
  return(
    <div className='cb-modal' id={`${modalId}`} aria-hidden='true'
      data-cb-apricot='modal'>
      <div className='cb-modal-overlay' tabIndex='-1'>
        <div className='cb-modal-container' role='dialog' aria-modal='true' aria-labelledby={`${modalId}_Title`} aria-describedby={`dialogueDsc_${modalId}`}>
          <div className='cb-modal-header'>
            <div id={`${modalId}_Title`} className='display-flex justify-content-start align-items-center headerStyle' style={{width: '100%'}}>
              <span style={{marginRight: '5px'}} className='cb-icon cb-icon-circular cb-megaphone'></span>
              <span style={{width:'100%', display: 'flex', flexWrap:'wrap'}}>{title}</span>
            </div>
            {/* <!-- close button --> */}
            <button type='button' className='cb-btn cb-btn-square cb-btn-greyscale cb-btn-close' aria-describedby={`${modalId}_Title`} data-cb-modal-close>
              <span className='cb-icon cb-x-mark' aria-hidden='true' />
              <span className='sr-only'>Close</span>
            </button>
          </div>
          <div className='cb-modal-content' id={`dialogueDsc_${modalId}`}>
            <p>Unsaved changes will be lost when you leave this page. Please save your changes
              in the following modules:</p>
            <div style={{margin: '20px 0px'}}>{bodycontent?.map(item => <div key={item}>{item}</div>)}</div>
          </div>
          <div className='cb-modal-footer'>
            {renderSubmitDesign()}
          </div>
        </div>
      </div>
    </div>
  );
}

export default forgottosavemodal;